import React from "react";
import { TextField, Grid, Box, IconButton, Alert } from "@mui/material";

import ReplayIcon from "@mui/icons-material/Replay";
const CaptchaCheck = ({
  setresObj,
  resObj,
  getCapImage,
  captchImg,
  onReloadCaptch,
  currentUserId,
  attemptsExhausted,
}) => {
  return (
    <>
      <Grid container>
        <Grid item xs={12} md={12} sx={{ p: 2, my: 2 }} className="captchaDiv">
          <Box>
            {" "}
            <Grid
              container
              spacing={2}
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs={12} sm={12} display="flex" justifyContent="center">
                {!attemptsExhausted && (
                  <img
                    style={{ width: "150px", height: "40px" }}
                    src={"data:image/png;base64," + captchImg}
                    alt={"Captcha"}
                    loading="lazy"
                  />
                )}
                {attemptsExhausted && (
                  <Alert severity="error" mt={1}>
                    You have exceeded the maximum number of attempts for captcha
                    generation, Please try again after sometime.
                  </Alert>
                )}
                <IconButton
                  type="IconButton"
                  size="small"
                  variant="contained"
                  sx={{ ml: 2 }}
                  onClick={() => {
                    resObj?.fileName?.length
                      ? onReloadCaptch()
                      : getCapImage(currentUserId);
                  }}
                >
                  <ReplayIcon />
                </IconButton>
              </Grid>
              {!attemptsExhausted && (
                <TextField
                  sx={{ my: 1, float: "left" }}
                  value={resObj?.captcha_txt}
                  margin="normal"
                  size="small"
                  className="signinText"
                  required
                  label="Captcha"
                  name="captcha_txt"
                  autoComplete="off"
                  onChange={(e) => {
                    setresObj({ ...resObj, captcha_txt: e.target.value });
                  }}
                />
              )}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default CaptchaCheck;
